
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'SettingsGroup',
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        }
    }
})
